import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Confirm from 'react-confirm-bootstrap';
import { toastr } from 'react-redux-toastr';
import { show } from 'redux-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AdvertiserApi } from '../../../../api';
import { Spinner } from '../../../../components/common';
import CardsFormModal from '../../../../components/advertisers/cards/CardsForm';
import { setLoader, removeLoader } from '../../../../actions';
import { ButtonEdit, ButtonDelete } from '../../../../components/common/buttons/actions';
import { ButtonAdd } from '../../../../components/common/buttons';

class Cards extends Component {
  componentDidMount() {
    this.fetchResource();
  }

  fetchResource(params = {}) {
    const { account, dispatch } = this.props;
    if (account.uuid) {
      const data = { ...params, account_id: account.uuid };
      dispatch(AdvertiserApi.actions.cards.get(data));
    }
  }

  handleEdit = (r) => {
    const { dispatch, account } = this.props;

    dispatch(show('CardFormModal', {
      card: r,
      formAction: 'Update',
      title: `Update Card (Ending in ${r.last4})`,
      account
    }));
  }

  handleAdd = () => {
    const { dispatch, account } = this.props;

    dispatch(show('CardFormModal', {
      formAction: 'Add',
      title: 'Add Card',
      account
    }));
  }

  handleDelete = (r) => {
    const { account, dispatch } = this.props;
    const params = { account_id: account.uuid, card_id: r.id };
    const data = { account_id: account.uuid };

    dispatch(setLoader('getCards'));

    dispatch(AdvertiserApi.actions.cardDelete.post(params, (error, success) => {
      dispatch(removeLoader('getCards'));
      if (success) {
        toastr.success('Card has successfully been deleted');
      } else if (error) {
        toastr.error(
          `Before deleting your last card make sure you 
          have paid any outstanding balance`
        );
      }
      dispatch(AdvertiserApi.actions.customers());
      dispatch(AdvertiserApi.actions.cards.get(data));
    }));
  }

  renderCard(c, r) {
    return (
      <span>
        <i className={`fa fa-cc-${r.brand === 'American Express' ? 'amex' : r.brand.toLowerCase()}`} aria-hidden="true" />
        &nbsp; <a onClick={this.handleEdit.bind(this, r)}>XXXX XXXX XXXX {c}</a>
      </span>
    );
  }

  renderTableActions = (c, r) => {
    const { cards } = this.props;
    const message = cards.data.length === 1 ?
      `If you choose to delete this card you will be billed immediately for any balance 
      accrued since the last invoice, are you sure you would like to proceed?` :
      'Are you sure you want to delete this card?';

    return (
      <ul className='list-inline'>
        <li>
          <ButtonEdit
            onClick={() => this.handleEdit(r)}
          />
        </li>
        <li>
          <Confirm
            onConfirm={() => this.handleDelete(r, c)}
            body={message}
            confirmText='Confirm Delete'
            title={'Deleting Card'}
            style={{ marginLeft: '10px' }}
          >
            <div><ButtonDelete /></div>
          </Confirm>
        </li>
      </ul>
    );
  }

  render() {
    const { isLoading, cards } = this.props;
    const { data } = cards || {};

    return (
      <div>
        <div className='ibox'>
          <div className='ibox-title'>
            <h5>Payment Options</h5>
          </div>
          <div className={`p-b-lg ibox-content${isLoading ? ' sk-loading' : ''}`}>
            <Spinner />
            <div className='m-b-sm text-left'>
              <ButtonAdd
                btnLabel='Add Card'
                onClick={() => this.handleAdd()}
              />
            </div>
            <BootstrapTable
              striped
              ref='CardsTable'
              data={data || []}
            >
              <TableHeaderColumn
                width="75"
                dataField="default_source"
                dataFormat={(c) => (c === true ? <FontAwesomeIcon icon="check-circle" style={{ color: 'green' }} /> : '')}
              >
                Default
              </TableHeaderColumn>

              <TableHeaderColumn
                width="200"
                dataField="last4"
                dataFormat={(c, r) => this.renderCard(c, r)}
              >
                Card
              </TableHeaderColumn>

              <TableHeaderColumn
                width="75"
                dataField="exp_year"
                dataFormat={(c, r) => `${r.exp_month}/${c.toString().slice(-2)}`}
              >
                Expiry
              </TableHeaderColumn>

              <TableHeaderColumn
                width="150"
                dataField="name"
                dataFormat={(c) => c}
              >
                Cardholder
              </TableHeaderColumn>

              <TableHeaderColumn
                width="250"
                dataField="address_line1"
              >
                Address
              </TableHeaderColumn>

              <TableHeaderColumn
                isKey
                width="100"
                dataField="uuid"
                dataFormat={this.renderTableActions}
              >
                Actions
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
        <CardsFormModal />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { loader, advertiser: { cards: { data: cards, loading }, accounts } } = state;
  const { params: { accountSlug } } = ownProps;
  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};
  const isLoading = loader.includes('getCards') || loading ? true : false;

  return { cards, isLoading, account };
};

export default connect(mapStateToProps)(Cards);
